<template>
  <div class="app-container">
    <!--工具栏-->
    <!--表单组件-->
    <eForm ref="form" :is-add="isAdd" />
    <!--表格渲染-->

    <!-- 表格1 start -->
    <el-table
      v-if="tableIndex === 2"
      v-loading="loading"
      :data="data"
      size="small"
      style="width: 100%"
    >
      <el-table-column prop="num" label="序号" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 + page * size }}
        </template>
      </el-table-column>
      <el-table-column prop="speciesId" label="种类" width="150" align="center">
        <template slot-scope="scope">
          {{ getOption(scope.row.speciesId, options1, "speciesName", "id") }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="subjectName" label="科目" align="center" /> -->
      <el-table-column prop="subjectId" label="科目" width="150" align="center">
        <template slot-scope="scope">
          {{
            getOption(scope.row.subjectId, options3, "subjectName", "subjectId")
          }}
        </template>
      </el-table-column>

      <!-- <el-table-column prop="yesterdayAnswer" label="昨日答案" align="center" />
      <el-table-column prop="todayProblems" label="今日音频" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.todayProblems"
            target="_blank"
            :href="scope.row.todayProblems"
            type="primary"
            >{{ scope.row.todayProblems }}</el-link
          >
        </template>
      </el-table-column> -->

      <el-table-column
        prop="toeflHearingListId"
        label="类型"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <span v-for="(item, index) in arrData" :key="index">
            <span v-if="item.id == scope.row.toeflHearingListId">
              <span v-for="(iitem, index) in open" :key="index">
                {{ iitem.id == item.type ? iitem.val : "" }}
              </span>
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="toeflHearingListId" label="日期" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in arrData" :key="index">
            <span v-if="item.id == scope.row.toeflHearingListId">{{
              item.topTime
            }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="toeflHearingListId" label="中文名" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in arrData" :key="index">
            <span v-if="item.id == scope.row.toeflHearingListId">{{
              item.cnTitle
            }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="toeflHearingListId" label="英文名" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in arrData" :key="index">
            <span v-if="item.id == scope.row.toeflHearingListId">{{
              item.enTitle
            }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="listenTitle" label="名称" align="center" />
      <el-table-column prop="audioUrl" label="音频" align="center" />

      <el-table-column
        label="操作"
        v-if="selectFlag === false"
        width="150px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          />
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id].doClose()"
              >
                取消
              </el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
                >确定
              </el-button>
            </div>
            <el-button
              slot="reference"
              type="danger"
              icon="el-icon-delete"
              size="mini"
            />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        v-if="selectFlag === true"
        label="操作"
        width="150px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            @click="changeAdd(scope.row.id)"
            v-if="selectActive(scope.row.id, num) === false"
            size="mini"
            type="primary"
            >选择</el-button
          >
          <el-button
            @click="changeDel(scope.row.id)"
            v-if="selectActive(scope.row.id, num) === true"
            size="mini"
            type="danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 表格1 end -->

    <!-- 表格2 start -->
    <el-table
      v-if="tableIndex === 2"
      v-loading="loading"
      :data="data"
      size="small"
      style="width: 100%"
    >
    </el-table>
    <!-- 表格2 end -->
    <!--分页组件-->
    <el-pagination
      :total="total"
      :current-page="page + 1"
      style="margin-top: 8px"
      layout="total, prev, pager, next, sizes"
      @size-change="sizeChange"
      @current-change="pageChange"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import initData from "@/mixins/initData";
import { delTable } from "@/api/table";
import { parseTime } from "@/utils/index";
import eForm from "./form";
import { getToeflHearingList } from "@/api/essenceListens";

export default {
  components: { eForm },
  mixins: [initData],
  props: {
    selectFlag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: null,
      open: [
        {
          id: 1,
          val: "技术",
        },
        {
          id: 2,
          val: "健康",
        },
        {
          id: 3,
          val: "地球",
        },
        {
          id: 4,
          val: "科学",
        },
        {
          id: 5,
          val: "心理",
        },
        {
          id: 6,
          val: "太空",
        },
      ],
      selectFlag: false,
      selectArr: {},
      num: 0,
      delLoading: false,
      tableIndex: 2,
      // options: [],
      options1: [],
      options3: [],
      arrData: [],
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
      this.getessencFn();
    });
  },
  methods: {
    checkPermission,
    getessencFn() {
      let url = `?page=0&size=999`;
      getToeflHearingList(url).then((val) => {
        this.arrData = val.content;
        for (let i in this.arrData) {
          this.arrData[i].jsonData = JSON.parse(this.arrData[i].jsonData);
        }
        console.log(this.arrData);
        console.log("this.arrData");
      });
    },
    changeAdd(e) {
      this.selectArr[e] = true;
      this.num++;
      this.$emit("selectOver", this.selectArr);
    },
    changeDel(e) {
      this.num--;
      delete this.selectArr[e];
      this.$emit("selectOver", this.selectArr);
    },
    selectActive(id) {
      return this.selectArr[id] === true ? true : false;
    },
    beforeInit() {
      this.url = "api/table/" + this.tableIndex;
      const sort = "id,desc";
      this.params = { page: this.page, size: this.size, sort: sort };
      if (this.speciesId || this.speciesId === 0) {
        this.params["speciesId"] = this.speciesId;
      }
      if (this.subjectId || this.subjectId === 0) {
        this.params["subjectId"] = this.subjectId;
      }
      if (this.type) {
        this.params["type"] = this.type;
      }
      return true;
    },
    subDelete(id) {
      this.delLoading = true;
      delTable(this.tableIndex, id)
        .then((res) => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleChangePage();
          this.init();
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500,
          });
        })
        .catch((err) => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err.response.data.message);
        });
    },
    add() {
      this.isAdd = true;
      this.$refs.form.dialog = true;
      this.$refs.form.options1 = this.options1;
      this.$refs.form.options3 = this.options3;
      this.$refs.form.tableIndex = this.tableIndex;
    },
    edit(data) {
      console.log(data);
      this.isAdd = false;
      const _this = this.$refs.form;
      _this.form = {
        id: data.id,
        // 种类id
        speciesId: data.speciesId,
        // 科目名称
        subjectId: data.subjectId,
        // 昨日答案
        yesterdayAnswer: data.yesterdayAnswer,
        // 今日音频
        todayProblems: data.todayProblems,
        toeflHearingListId: data.toeflHearingListId,
      };
      console.log(_this.form);
      // 中文名英文名
      let txt1, txt2;
      for (let i in this.arrData) {
        if (this.arrData[i].id == data.toeflHearingListId) {
          txt1 = this.arrData[i].cnTitle;
          txt2 = this.arrData[i].enTitle;
        }
      }
      _this.txt1 = txt1;
      _this.txt2 = txt2;
      _this.options1 = this.options1;
      _this.options3 = this.options3;
      _this.tableIndex = this.tableIndex;
      _this.dialog = true;
    },
    getOption(id, option, name, sid) {
      if (!option && option.length === 0) return "";
      for (let i in option) {
        if (+option[i][sid] === +id) {
          return option[i][name];
        }
      }
    },
  },
  beforeMount() {},
};
</script>

<style scoped>
</style>
